/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Private_BodyInputs */

const en_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The core of every program. Full swing, short game, mechanics, video. Built around what your game needs most.`)
};

const es_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La base de cada programa. Swing completo, juego corto, mecánica y video. Diseñada en torno a lo que más necesita tu juego.`)
};

const de_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kern jedes Programms. Full Swing, kurzes Spiel, Mechanik, Video. Ausgerichtet auf das, was Ihr Spiel am meisten braucht.`)
};

const zh_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个项目的核心。全挥杆、短杆、动作要领与视频分析。围绕你的球技最需要改进的地方来设计。`)
};

const ar_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أساس كل برنامج: الضربة الكاملة، واللعب القصير، والميكانيكا، والفيديو. مصمَّم حول ما تحتاجه لعبتك أكثر من أي شيء آخر.`)
};

const fr_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le cœur de chaque programme. Swing complet, jeu court, mécanique, vidéo. Construit autour de ce dont votre jeu a le plus besoin.`)
};

const vi_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nền tảng của mọi chương trình: full swing, lối chơi ngắn, cơ học chuyển động và video. Được thiết kế xoay quanh điều mà lối chơi của bạn cần nhất.`)
};

const sw_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msingi wa kila programu. Swing kamili, mchezo mfupi, ufundi wa swing, video. Imeundwa kulingana na kile ambacho mchezo wako unahitaji zaidi.`)
};

const th_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หัวใจของทุกโปรแกรม สวิงเต็มตัว เกมสั้น กลไก และวิดีโอ ออกแบบตามสิ่งที่เกมของคุณต้องการมากที่สุด`)
};

const bs_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Srž svakog programa. Puni swing, kratka igra, mehanika, video. Građeno oko onoga što vaša igra najviše treba.`)
};

const ja_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのプログラムの核となるレッスン。フルスイング、ショートゲーム、メカニクス、ビデオ分析。あなたのゲームにいちばん必要なことを中心に組み立てます。`)
};

const ko_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 프로그램의 핵심입니다. 풀스윙, 숏게임, 스윙 메커니즘, 영상 분석. 내 골프에 가장 필요한 부분을 중심으로 구성합니다.`)
};

const pt_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A base de todo programa. Swing completo, jogo curto, mecânica, vídeo. Montada em torno do que seu jogo mais precisa.`)
};

const it_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il cuore di ogni programma. Swing completo, gioco corto, meccanica, video. Pensato in base a ciò di cui il tuo gioco ha più bisogno.`)
};

const sv_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kärnan i varje program. Full sving, kort spel, teknik, video. Upplagd kring det ditt spel behöver mest.`)
};

const nl_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De kern van elk programma. Volledige swing, het korte spel, techniek, video. Opgebouwd rond wat jouw spel het meest nodig heeft.`)
};

const da_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kernen i ethvert program. Fuldt sving, det korte spil, teknik, video. Bygget op omkring det, dit spil har mest brug for.`)
};

const nb_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjernen i hvert program. Full sving, kortspill, teknikk, video. Bygget rundt det spillet ditt trenger mest.`)
};

const fi_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokaisen ohjelman ydin. Täysi swing, lähipeli, mekaniikka, video. Rakennettu sen ympärille, mitä pelisi eniten tarvitsee.`)
};

const pl_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podstawa każdego programu. Pełny swing, krótka gra, technika, wideo. Wszystko dopasowane do tego, czego twoja gra potrzebuje najbardziej.`)
};

const ru_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основа любой программы. Полный свинг, короткая игра, техника, видео. Строится вокруг того, что больше всего нужно вашей игре.`)
};

const tr_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her programın temeli. Tam swing, kısa oyun, mekanik, video. Oyununuzun en çok ihtiyaç duyduğu şeye göre şekillenir.`)
};

const hi_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हर प्रोग्राम का मूल आधार। फुल स्विंग, शॉर्ट गेम, तकनीक, वीडियो। आपके खेल को जिस चीज़ की सबसे ज़्यादा ज़रूरत है, उसी के इर्द-गिर्द तैयार।`)
};

const id_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inti dari setiap program. Ayunan penuh, permainan jarak pendek, mekanika, video. Disusun berdasarkan apa yang paling dibutuhkan permainan Anda.`)
};

const ms_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teras setiap program. Hayunan penuh, permainan pendek, mekanik, video. Dibina mengikut apa yang paling diperlukan oleh permainan anda.`)
};

const cs_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jádro každého programu. Plný švih, krátká hra, technika, video. Postavené na tom, co vaše hra potřebuje nejvíc.`)
};

const el_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η βάση κάθε προγράμματος. Πλήρες σβινγκ, κοντό παιχνίδι, μηχανική, βίντεο. Χτισμένο γύρω από ό,τι χρειάζεται περισσότερο το παιχνίδι σας.`)
};

const he_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הליבה של כל תוכנית: סווינג מלא, משחק קצר, מכניקה ווידאו. נבנה סביב מה שהמשחק שלכם צריך יותר מכול.`)
};

const af_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die kern van elke program. Volle swaai, kortspel, meganika, video. Opgebou rondom wat jou spel die nodigste het.`)
};

const hu_lessons_format_private_body = /** @type {(inputs: Lessons_Format_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden program alapja. Teljes swing, rövid játék, technika, videó. Arra épül, amire a játékodnak a legnagyobb szüksége van.`)
};

/**
* | output |
* | --- |
* | "The core of every program. Full swing, short game, mechanics, video. Built around what your game needs most." |
*
* @param {Lessons_Format_Private_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_private_body = /** @type {((inputs?: Lessons_Format_Private_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Private_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_private_body(inputs)
	if (locale === "de") return de_lessons_format_private_body(inputs)
	if (locale === "zh") return zh_lessons_format_private_body(inputs)
	if (locale === "ar") return ar_lessons_format_private_body(inputs)
	if (locale === "fr") return fr_lessons_format_private_body(inputs)
	if (locale === "vi") return vi_lessons_format_private_body(inputs)
	if (locale === "sw") return sw_lessons_format_private_body(inputs)
	if (locale === "th") return th_lessons_format_private_body(inputs)
	if (locale === "bs") return bs_lessons_format_private_body(inputs)
	if (locale === "ja") return ja_lessons_format_private_body(inputs)
	if (locale === "ko") return ko_lessons_format_private_body(inputs)
	if (locale === "pt") return pt_lessons_format_private_body(inputs)
	if (locale === "it") return it_lessons_format_private_body(inputs)
	if (locale === "sv") return sv_lessons_format_private_body(inputs)
	if (locale === "nl") return nl_lessons_format_private_body(inputs)
	if (locale === "da") return da_lessons_format_private_body(inputs)
	if (locale === "nb") return nb_lessons_format_private_body(inputs)
	if (locale === "fi") return fi_lessons_format_private_body(inputs)
	if (locale === "pl") return pl_lessons_format_private_body(inputs)
	if (locale === "ru") return ru_lessons_format_private_body(inputs)
	if (locale === "tr") return tr_lessons_format_private_body(inputs)
	if (locale === "hi") return hi_lessons_format_private_body(inputs)
	if (locale === "id") return id_lessons_format_private_body(inputs)
	if (locale === "ms") return ms_lessons_format_private_body(inputs)
	if (locale === "cs") return cs_lessons_format_private_body(inputs)
	if (locale === "el") return el_lessons_format_private_body(inputs)
	if (locale === "he") return he_lessons_format_private_body(inputs)
	if (locale === "af") return af_lessons_format_private_body(inputs)
	if (locale === "hu") return hu_lessons_format_private_body(inputs)
	return en_lessons_format_private_body(inputs)
});